import { Box, Button, Chip, List, ListItem, ListItemText, Modal, Paper, Stack, Typography } from "@mui/material";
import { DrawResult } from "../../../../interface/MainInterface";
import { useMemo } from "react";

interface PropsType {
  openModal: boolean;
  closeModal: () => void;
  drawResult: DrawResult[];
  onAnnounce: (prizeName: string, winners: any[]) => void;
}

const DrawInfoModule = ({ openModal, closeModal, drawResult, onAnnounce }: PropsType) => {
  const groupedWinners = useMemo(() => {
    const groups: { [key: string]: any[] } = {};

    drawResult.forEach((winner) => {
      const prizeName = winner.ofrNm;
      if (!groups[prizeName]) {
        groups[prizeName] = [];
      }
      groups[prizeName].push(winner);
    });

    return groups;
  }, [drawResult]);

  const handleIndividualAnnounce = (prizeName: string, winners: any[]) => {
    if (window.confirm(`'${prizeName}' 당첨자(${winners.length}명) 공지를 등록하시겠습니까?`)) {
      onAnnounce(prizeName, winners);
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "500px", // 내용이 많아지므로 폭을 조금 더 확보
          maxHeight: "85vh",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2} sx={{ height: "100%" }}>
          <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "18px" }}>경품별 당첨자 관리</Typography>
            <Box
              component="img"
              src="/images/icon-close.png"
              alt="닫기"
              sx={{ width: 16, height: 16, cursor: "pointer", opacity: 0.6 }}
              onClick={closeModal}
            />
          </Stack>

          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            {Object.keys(groupedWinners).length === 0 ? (
              <Box sx={{ p: 4, textAlign: "center", color: "text.secondary" }}>당첨 내역이 없습니다.</Box>
            ) : (
              Object.entries(groupedWinners).map(([prizeName, winners]) => (
                <Paper key={prizeName} variant="outlined" sx={{ mb: 1, p: 2, borderRadius: 2, borderColor: "divider" }}>
                  {/* 각 경품 헤더 */}
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={1} alignItems="center"
                      sx={{
                        minWidth: 0,
                      }}>
                      <Chip label={prizeName} color="primary" size="small" sx={{
                        fontWeight: "bold",
                        minWidth: 0,
                      }} />
                      <Typography variant="body2" fontWeight="bold" sx={{ flexShrink: 0 }}>
                        총 {winners.length}명
                      </Typography>
                    </Stack>
                  </Stack>

                  {/* 당첨자 명단 (간략히 보기) */}
                  <List
                    dense
                    sx={{
                      bgcolor: "#f9f9f9",
                      borderRadius: 1,
                      mb: 2,
                      maxHeight: "150px",
                      overflowY: "auto",
                    }}
                  >
                    {winners.map((winner, idx) => (
                      <ListItem key={winner.user_id + idx} divider={idx !== winners.length - 1}>
                        <ListItemText primary={`${winner.user_id}`} primaryTypographyProps={{ fontSize: "0.875rem" }} />
                      </ListItem>
                    ))}
                  </List>

                  {/* ★ 경품별 공지 버튼 ★ */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="small"
                    onClick={() => handleIndividualAnnounce(prizeName, winners)}
                    sx={{ fontWeight: "bold" }}
                  >
                    당첨 공지 전송
                  </Button>
                </Paper>
              ))
            )}
          </Box>

          {/* 하단 닫기 버튼 (공지 버튼들이 위로 올라갔으므로 닫기만 존재) */}
          <Button variant="outlined" onClick={closeModal} sx={{ py: 1 }}>
            닫기
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DrawInfoModule;
